/**
 * Окунёвые — 13 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ОКУНЁВЫЕ = [
    // ── Наши воды ──
    {
        id: 'perch',
        семейство: 'окунёвые',
        latin: 'Perca fluviatilis',
        повадка: 'стайная_бель',
        minKg: 0.04,
        maxKg: 1.3,
        typicalKg: 0.18,
        typicalLengthM: 0.22,
        depthM: 1.2,
        depthBandM: 2.2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 1, опт: 18, макс: 27 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
        вИгре: 'perch',
    },
    {
        id: 'zander',
        семейство: 'окунёвые',
        latin: 'Sander lucioperca',
        повадка: 'донный_хищник',
        minKg: 0.4,
        maxKg: 6,
        typicalKg: 1.1,
        typicalLengthM: 0.48,
        depthM: 4.5,
        depthBandM: 2.5,
        сложение: 'округлое',
        пасть: 'панцирная',
        /*
         * ⚠️ ПОЛУТОЛЩИНА ЗАМЕРЕНА ПО МОДЕЛИ И ПРАВИЛОМ НЕ ВЫВОДИТСЯ. Правило даёт
         * 0.078 — как у щуки, — и три независимых разбора отказались воспроизводить
         * 0.148: судак прогонистее щуки, а число вдвое больше её. Похоже, модель
         * вылеплена бочкой либо мерили по другой оси.
         *
         * Оставляем замер: по нему живая игра кладёт рыбу на мель, и до этого
         * замера она тонула в песке по спину. Подогнать правило под подозрительное
         * число значило бы спрятать вопрос; поправка держит его на виду.
         */
        поправки: { halfThickFrac: 0.148 },
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 2, опт: 18, макс: 28 },
        течение: 'любое',
        держится: ['бровка', 'твёрдое_дно', 'яма'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'jig', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'spinner', вес: 0.2 },
            { чем: 'червь', вес: 0.2 },
        ],
        вИгре: 'zander',
    },
    {
        id: 'volga_zander',
        семейство: 'окунёвые',
        latin: 'Sander volgensis',
        повадка: 'донный_хищник',
        minKg: 0.2,
        maxKg: 1.8,
        typicalKg: 0.5,
        typicalLengthM: 0.32,
        depthM: 4,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'панцирная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['бровка', 'твёрдое_дно', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'jig', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spinner', вес: 0.2 },
        ],
    },
    {
        id: 'ruffe',
        семейство: 'окунёвые',
        latin: 'Gymnocephalus cernua',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.25,
        typicalKg: 0.04,
        typicalLengthM: 0.11,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 1, опт: 12, макс: 22 },
        течение: 'слабое',
        держится: ['ил', 'яма', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
    {
        id: 'donets_ruffe',
        семейство: 'окунёвые',
        latin: 'Gymnocephalus acerinus',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.2,
        typicalKg: 0.04,
        typicalLengthM: 0.12,
        depthM: 4,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'ночная',
        вода: { мин: 2, опт: 14, макс: 24 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'ручейник', вес: 0.2 },
        ],
    },
    {
        id: 'zingel',
        семейство: 'окунёвые',
        latin: 'Zingel zingel',
        повадка: 'мелочь',
        minKg: 0.05,
        maxKg: 0.5,
        typicalKg: 0.15,
        typicalLengthM: 0.2,
        depthM: 4,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 4, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['камни', 'твёрдое_дно', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'streber',
        семейство: 'окунёвые',
        latin: 'Zingel streber',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.2,
        typicalKg: 0.06,
        typicalLengthM: 0.14,
        depthM: 3.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 4, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['камни', 'твёрдое_дно', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'опарыш', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'percarina',
        семейство: 'окунёвые',
        latin: 'Percarina demidoffii',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.05,
        typicalKg: 0.015,
        typicalLengthM: 0.08,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 8, опт: 22, макс: 28 },
        течение: 'слабое',
        держится: ['открытая_вода', 'ил'],
        стая: 'большая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'рачок', вес: 0.6 },
        ],
        краснокнижная: true,
    },
    // ── Балканы, Дунай и Междуречье ──
    {
        id: 'schraetzer',
        семейство: 'окунёвые',
        latin: 'Gymnocephalus schraetser',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.25,
        typicalKg: 0.08,
        typicalLengthM: 0.18,
        depthM: 4,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 3, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'ручейник', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Западная и Северная Европа ──
    {
        id: 'apron',
        семейство: 'окунёвые',
        latin: 'Zingel asper',
        повадка: 'мелочь',
        minKg: 0.01,
        maxKg: 0.15,
        typicalKg: 0.05,
        typicalLengthM: 0.15,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'единичная',
        когда: 'ночная',
        вода: { мин: 4, опт: 13, макс: 20 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'ручейник', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    // ── Восточная Европа, Кавказ, Средняя Азия и Сибирь ──
    {
        id: 'balkhash_perch',
        семейство: 'окунёвые',
        latin: 'Perca schrenkii',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 1.2,
        typicalKg: 0.3,
        typicalLengthM: 0.28,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 2, опт: 20, макс: 28 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
        ],
    },
    // ── Северная Америка ──
    // Великие озёра и Миссисипи: уоллай, маскинонг, краппи, сомы и осетры.
    {
        id: 'walleye',
        семейство: 'окунёвые',
        latin: 'Sander vitreus',
        повадка: 'донный_хищник',
        minKg: 0.2,
        maxKg: 5,
        typicalKg: 0.9,
        typicalLengthM: 0.48,
        depthM: 5,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'панцирная',
        редкость: 'обычная',
        когда: 'ночная',
        вода: { мин: 2, опт: 18, макс: 26 },
        течение: 'любое',
        держится: ['бровка', 'твёрдое_дно', 'яма'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'jig', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
        ],
    },
    {
        id: 'yellow_perch',
        семейство: 'окунёвые',
        latin: 'Perca flavescens',
        повадка: 'стайная_бель',
        minKg: 0.04,
        maxKg: 0.8,
        typicalKg: 0.15,
        typicalLengthM: 0.22,
        depthM: 4,
        depthBandM: 3,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 1, опт: 16, макс: 25 },
        течение: 'слабое',
        держится: ['бровка', 'трава', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'мотыль', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=percids.js.map